// Angular Files
import { Injectable } from '@angular/core';

// Other External Files
import { Observable } from 'rxjs';

// Teller Online Files
import {
    AuthorizationTextApiClient,
    AuthorizationTextVersionDto,
    CreateAuthorizationTextVersionRequestDto,
    PaymentAuthorizationTypeEnumDto,
    PaymentTypeEnumDto
} from 'apps/admin-portal/src/app/core/api/AdminPortalApiClients';

/**
 * Thin wrapper around the generated `AuthorizationTextApiClient` for the
 * TO Config admin "Authorization Texts" feature (TOP-2935). All methods
 * are pass-throughs; per-call error mapping happens at the component
 * layer because conflict/stale responses carry useful payload that
 * components handle inline.
 */
@Injectable({
    providedIn: 'root'
})
export class AuthorizationTextService {
    constructor(
        private apiClient: AuthorizationTextApiClient
    ) {}

    public listActive(): Observable<AuthorizationTextVersionDto[]> {
        return this.apiClient.listActiveAuthorizationTexts();
    }

    public createVersion(
        body: CreateAuthorizationTextVersionRequestDto
    ): Observable<AuthorizationTextVersionDto> {
        return this.apiClient.createAuthorizationTextVersion(body);
    }

    public getHistory(
        paymentMethodType: PaymentTypeEnumDto,
        authorizationType: PaymentAuthorizationTypeEnumDto
    ): Observable<AuthorizationTextVersionDto[]> {
        return this.apiClient.getAuthorizationTextHistory(paymentMethodType, authorizationType);
    }

    public deactivate(versionId: number): Observable<void> {
        return this.apiClient.deactivateAuthorizationTextVersion(versionId);
    }
}
